import api from "./api";

let pendingRefresh = null;
const tokenKey = () => { const slug = window.location?.pathname?.match(/^\/app\/([a-f0-9]{16})(?:\/|$)/)?.[1]; return slug ? `token:${slug}` : "token"; };
export function getAccessToken() {
  try { return JSON.parse(localStorage.getItem(tokenKey())) || null; }
  catch (error) { localStorage.removeItem(tokenKey()); return null; }
}
export function saveAccessToken(token) {
  localStorage.setItem(tokenKey(), JSON.stringify(token));
  api.defaults.headers.Authorization = `Bearer ${token}`;
  window.dispatchEvent(new Event("zapticket:token-updated"));
}
export function clearSession() {
  localStorage.removeItem(tokenKey());
  delete api.defaults.headers.Authorization;
  window.dispatchEvent(new Event("zapticket:token-updated"));
}
export function refreshSession() {
  if (!pendingRefresh) {
    const originalToken = getAccessToken();
    pendingRefresh = api.post("/auth/refresh_token", null, { _skipAuthRefresh: true })
      .then(({ data }) => {
        if (!data?.token || getAccessToken() !== originalToken) {
          throw new Error("Session changed during refresh");
        }
        saveAccessToken(data.token);
        return data;
      }).finally(() => { pendingRefresh = null; });
  }
  return pendingRefresh;
}
